import { IconProps } from 'types/icon.type'

export const BoxIcon = (props: IconProps) => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Box icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7953 3.77896C25.7699 3.21714 26.875 2.92139 28 2.92139C29.1249 2.92139 30.23 3.21712 31.2046 3.77889L31.2083 3.78106L47.5417 13.1144C48.5162 13.677 49.3256 14.486 49.8887 15.4602C50.4518 16.4344 50.7488 17.5396 50.75 18.6648V37.3333C50.7488 38.4585 50.4518 39.5655 49.8887 40.5397C49.3256 41.5139 48.5162 42.3229 47.5417 42.8855L47.5349 42.8894L31.2083 52.2188L31.2046 52.221C30.2301 52.7827 29.1249 53.0785 28 53.0785C26.875 53.0785 25.7698 52.7827 24.7953 52.2209L24.7917 52.2188L8.46509 42.8894L8.45833 42.8855C7.48384 42.3229 6.67444 41.5139 6.11131 40.5397C5.54819 39.5655 5.25116 38.4603 5.25 37.3351L5.25 18.6666C5.25115 17.5414 5.54819 16.4344 6.11131 15.4602C6.67444 14.486 7.48384 13.677 8.45833 13.1144L8.46508 13.1105L24.7953 3.77896ZM28 6.42139C27.488 6.42139 26.9851 6.55615 26.5417 6.81215L26.5349 6.81603L10.2083 16.1455L10.2055 16.1471C9.7638 16.4028 9.39692 16.7699 9.14151 17.2118C8.88568 17.6543 8.75067 18.1564 8.75 18.6676V37.3323C8.75067 37.8435 8.88568 38.3455 9.14151 38.7881C9.39689 39.2299 9.76372 39.597 10.2053 39.8526L10.2083 39.8544L26.5417 49.1877C26.9851 49.4437 27.488 49.5785 28 49.5785C28.512 49.5785 29.0149 49.4437 29.4583 49.1877L29.4651 49.1838L45.7917 39.8544L45.7947 39.8526C46.2363 39.597 46.6031 39.2299 46.8585 38.7881C47.1145 38.3453 47.2495 37.8429 47.25 37.3315V18.6684C47.2495 18.1569 47.1145 17.6546 46.8585 17.2118C46.6031 16.7699 46.2362 16.4028 45.7945 16.1471L45.7917 16.1455L29.4583 6.81216C29.0149 6.55617 28.512 6.42139 28 6.42139Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.18273 15.4613C6.66432 14.6233 7.73403 14.3344 8.572 14.816L28 25.9815L47.428 14.816C48.266 14.3344 49.3357 14.6233 49.8173 15.4613C50.2989 16.2992 50.01 17.369 49.172 17.8505L29.75 29.0126V51.3333C29.75 52.2998 28.9665 53.0833 28 53.0833C27.0335 53.0833 26.25 52.2998 26.25 51.3333V29.0126L6.828 17.8505C5.99004 17.369 5.70114 16.2992 6.18273 15.4613Z"
        fill="currentColor"
      />
    </svg>
  )
}
